import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "../SectionHeading";
import { LIVE_ACCOUNT_URL } from "../../lib/api";

const NETWORK =
    "https://static.prod-images.emergentagent.com/jobs/51f38290-0410-404e-b160-085423ca1b2a/images/82a6c72be8c0c162864966fc4c74cdaf6d169cfe4376fdd7b52631fdcb591881.png";

const imageEnter = {
    initial: { opacity: 0, scale: 0.96 },
    whileInView: { opacity: 1, scale: 1 },
    viewport: { once: true },
    transition: { duration: 0.7 },
};

const points = [
    "Segregated client accounts at tier-1 banks",
    "Negative balance protection on retail accounts",
    "Documented best-execution policy",
    "Annual external audit and ongoing AML review",
];

export default function AboutRegulation() {
    return (
        <section className="py-24 lg:py-32">
            <div className="xpo-container grid lg:grid-cols-2 gap-12 items-center">
                <motion.img
                    {...imageEnter}
                    src={NETWORK}
                    alt="Global network"
                    className="rounded-2xl border border-white/10"
                />
                <div>
                    <SectionHeading
                        overline="Regulation"
                        title="Registered in Anjouan, Union of Comoros."
                        description="XPO Markets Ltd (Company No. 16297) is registered as an International Business Company by the Registrar of International Business Companies, Autonomous Island of Anjouan, Union of Comoros, under the International Business Companies Act 004 of 2005. The framework requires segregation of client funds, AML/KYC procedures, and an independent complaints mechanism."
                    />
                    <ul className="mt-8 space-y-3 text-slate-300">
                        {points.map((point) => (
                            <li key={point} className="flex items-start gap-3">
                                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#A6E3DC]" />{" "}
                                {point}
                            </li>
                        ))}
                    </ul>
                    <a
                        href={LIVE_ACCOUNT_URL}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="about-cta-open-account"
                        className="btn-outline-mint mt-9"
                    >
                        Open an account <ArrowUpRight size={16} />
                    </a>
                </div>
            </div>
        </section>
    );
}
